export interface IToken {
  network: number;
  tokenId: string;
  contractAddress: string;
  value: number;
  remaining: number;
  name?: string;
  description?: string;
  image?: string;
  eip5639?: boolean;
  eip5639Address?: string;
  eip5131?: boolean;
  eip5131Address?: string;
  delegateAddress?: string;
  ownerAddress?: string;
}
export class Token implements IToken {
  network: number;
  tokenId: string;
  contractAddress: string;
  value: number;
  remaining: number;
  name?: string;
  description?: string;
  image?: string;
  eip5639?: boolean;
  eip5639Address?: string;
  eip5131?: boolean;
  eip5131Address?: string;
  delegateAddress?: string;
  ownerAddress?: string;

  constructor(
    network: number,
    tokenId: string,
    contractAddress: string,
    value: number,
    remaining: number,
    name: string,
    description: string,
    image: string,
    eip5639: boolean,
    eip5639Address: string,
    eip5131: boolean,
    eip5131Address: string,
    delegateAddress: string,
    ownerAddress: string
  ) {
    this.network = network;
    this.tokenId = tokenId;
    this.contractAddress = contractAddress;
    this.value = value;
    this.remaining = remaining;
    this.name = name;
    this.description = description;
    this.image = image;
    this.eip5639 = eip5639;
    this.eip5639Address = eip5639Address;
    this.eip5131 = eip5131;
    this.eip5131Address = eip5131Address;
    this.delegateAddress = delegateAddress;
    this.ownerAddress = ownerAddress;
  }

  static fromJson(data: any) {
    return new Token(
      data.network,
      data.tokenId,
      data.contractAddress,
      data.value,
      data.remaining,
      data.name,
      data.metadata ? data.metadata.description : '',
      data.image,
      data.eip5639 ? data.eip5639 : false,
      data.eip5639Address ? data.eip5639Address : '',
      data.eip5131 ? data.eip5131 : false,
      data.eip5131Address ? data.eip5131Address : '',
      data.delegateAddress ? data.delegateAddress : '',
      data.ownerAddress
    );
  }
}
